import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  stepperStyle: {
    '& .MuiStepIcon-active': { color: '#034DDC' },
    '& .MuiStepIcon-completed': { color: '#034DDC' },
  },
});
